export default __webpack_public_path__ + "static/media/numbers.123001cd.svg";